import React, { useState, useEffect } from "react";

import { AiOutlineInfoCircle } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constant from "../../../_config/constant";
import {loadConnectAndInitialize} from '@stripe/connect-js';
import {
    ConnectComponentsProvider,
    ConnectAccountOnboarding
  } from "@stripe/react-connect-js";
import {
    authHeader
  } from "../../../_helpers";
import { bankService } from "../../../_services";

var Modal = require("react-bootstrap-modal");


export const PayoutMethod = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  saveAsDraft,
  draftRequesting,
  hostDetail,
  setIspaymentConfirm,
  isPaymentConfirm,
  setIsButtonDisable,
  isButtonDisable
}) => {
  const [payoutVerified, setPayoutVerified] = useState(null);
  const [payoutAccount, setPayoutAccount] = useState(null);
  const [stepForm, setStepForm] = useState({
    perNightPrice: formData.perNightPrice,
    extraChargePerGuest: formData.extraChargePerGuest,
    perMonthPrice: formData.perMonthPrice,
    cleaningFee: formData.cleaningFee,
    securityDeposite: formData.securityDeposite,
    lineholderDiscountType: formData.lineholderDiscountType,
    lineholderDiscount: formData.lineholderDiscount,
  });
  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    setFormData({ ...formData, ...stepForm, [tag]: value });
  };

  // /stripe-account-update-payout does not exist on the API - every call to it 404s, and
  // the 404's HTML body then threw inside response.json() before any toast could fire,
  // leaving Next silently disabled forever with no visible error and no way to recover.
  // Check the account the same way Settings > Payout Method already does successfully,
  // and skip the onboarding widget entirely once Stripe confirms the account is verified -
  // a host who already completed this from Settings should not be sent through it again.
  const checkStripePayoutVerified = async () => {
    const res = await bankService.getStripeDetail();
    return Boolean(res && res.data && res.data.charges_enabled && res.data.payouts_enabled);
  };

  // Mirrors the account summary Settings > Payout Method already shows, using the same
  // fields (bank_name, default_for_currency, routing_number, last4) from the same
  // GET /bank/list response, so a host sees the exact account they already set up rather
  // than a bare "you're verified" message.
  useEffect(() => {
    let cancelled = false;
    checkStripePayoutVerified()
      .then(async verified => {
        if (cancelled) return;
        setPayoutVerified(verified);
        if (!verified) return;
        setIspaymentConfirm(true);
        try {
          const res = await bankService.bankList();
          const accounts = res && res.status && res.data && Array.isArray(res.data.data) ? res.data.data : [];
          if (!cancelled) setPayoutAccount(accounts.find(account => account.default_for_currency) || accounts[0] || null);
        } catch (error) {
          // Non-fatal - the verified banner still shows without the bank details.
        }
      })
      .catch(() => {
        if (!cancelled) setPayoutVerified(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Clicking Next only matters once payoutVerified is already true (that is what enables
  // the button in the first place) - re-querying Stripe here was a redundant network call
  // with no new information to gain, and a transient failure on that extra call alone
  // produced a false "Unable to verify" error for a host who was already confirmed fine.
  const handleNextStep = (e) => {
    e.preventDefault();
    if (!payoutVerified) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onNext();
  };

  const [hideButtons, setHideButtons] = useState(false);
  //Stripe Code 
  
  const [stripeConnectInstance] = useState(() => {
    console.log("stripehere");
    
    const fetchClientSecret = async () => {
      //return "accs_secret__RQTyaKyXymHnukgVBBBMxRu8hbHUtB057FD0YB2eItUjzyw";
      // Fetch the AccountSession client secret
      const response = await fetch(constant.apiUrl+'/stripe-account-create', { method: "GET" , headers: { ...authHeader(), "Content-Type": "application/json" }});
     
      if (!response.ok) {
        // Handle errors on the client side here
        const {error} = await response.json();
        console.error('An error occurred: ', error);
        // document.querySelector('#error').removeAttribute('hidden');
        return undefined;
      } else {
        const data = await response.json();
        return data.data.client_secret;
      }
    }

    return loadConnectAndInitialize({
      // This is your test publishable API key.
      //replace this with env var while pushing code note-deploy
      publishableKey:  process.env.REACT_APP_STRIPE_API_KEY,// "pk_test_51Iu3xqBryti39zXvQNb9k2efXmKmEpiKqyXcS13X45bqOtmk9UCKzRKZX5CEuOUl0WArEm6W0SJkLIhFxOIf7EsX006Ltaz5Gz",
      fetchClientSecret: fetchClientSecret,
    })
  });

  
  //Stripe Code

  const updateStripeUserAccout = async () => {
    try {
      const verified = await checkStripePayoutVerified();
      if (verified) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setIspaymentConfirm(true);
        onNext();
      } else {
        toast.info('Your payout account is still under review. Please check back shortly.');
      }
    } catch (error) {
      toast.error('Unable to verify Stripe account status. Please try again later.');
    }
  };
  const saveAsdraft = (e) => {
    // if (
    //   stepForm.perNightPrice <= 0 ||
    //   stepForm.perMonthPrice <= 0 ||
    //   stepForm.securityDeposite <= 0 ||
    //   stepForm.extraChargePerGuest <= 0
    // ) {
    //   toast.info("Prices cannot be zero or less.");
    //   return;
    // }
    setFormData({ ...formData, ...stepForm });
    saveAsDraft();
  };
  return (
    <form onSubmit={handleNextStep}>
      <div className={className}>
        <div>
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              11
            </span>{" "}
            Payout Method
          </h4>
          <div className="col-lg-6 mb-2"></div>
          <div className="row">
            {payoutVerified === null ? (
              <p className="tw-text-sm tw-text-gray-500">Checking your payout account…</p>
            ) : payoutVerified ? (
              <div className="alert alert-success" role="status">
                <p className="tw-mb-2">Your payout method is already verified with Stripe.</p>
                {payoutAccount && (
                  <div className="tw-text-sm tw-mb-2">
                    <strong className="tw-capitalize">{payoutAccount.bank_name}</strong>
                    {payoutAccount.default_for_currency && (
                      <span className="tw-capitalize tw-bg-blue-500 tw-text-white tw-text-xs tw-p-1 tw-rounded tw-mx-2">
                        Primary
                      </span>
                    )}
                    <p className="tw-mb-0">Routing number: {payoutAccount.routing_number}</p>
                    <p className="tw-mb-0">Account number: XXXXXXXXXXXX{payoutAccount.last4}</p>
                  </div>
                )}
                <p className="tw-mb-0">You're all set — click Next to continue.</p>
              </div>
            ) : (
              <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                <ConnectAccountOnboarding
                     onExit={() => {
                        updateStripeUserAccout();
                    }}
                    />
                </ConnectComponentsProvider>
            )}
          </div>
        </div>
        <div className="payout-property-margin"  style={{ marginTop: "200px !important" }}>
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>

          <button
            disabled={!isPaymentConfirm}
            onClick={(e) => handleNextStep(e)}
            className="btn btn-secondary tw-mb-2"
          >
            Next
          </button>
          
        </div>
      </div>
    </form>
  );
};
